import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import Vue from 'vue';
import QIcon from "../icon/QIcon.js";
import ListenersMixin from "../../mixins/listeners.js";
import { slot, uniqueSlot } from "../../utils/private/slot.js";
export default Vue.extend({
  name: 'QTh',
  mixins: [ListenersMixin],
  props: {
    props: Object,
    autoWidth: Boolean
  },
  render: function render(h) {
    var _this = this;
    var on = _objectSpread({}, this.qListeners);
    if (this.props === void 0) {
      return h('th', {
        on: on,
        class: this.autoWidth === true ? 'q-table--col-auto-width' : null
      }, slot(this, 'default'));
    }
    var col, child;
    var name = this.$vnode.key;
    if (name) {
      col = this.props.colsMap[name];
      if (col === void 0) {
        return;
      }
    } else {
      col = this.props.col;
    }
    if (col.sortable === true) {
      var action = col.align === 'right' ? 'unshift' : 'push';
      child = uniqueSlot(this, 'default', []);
      child[action](h(QIcon, {
        props: {
          name: this.$q.iconSet.table.arrowUp
        },
        staticClass: col.__iconClass
      }));
    } else {
      child = slot(this, 'default');
    }
    var evt = col.sortable === true ? {
      click: function click(evt) {
        _this.props.sort(col);
        _this.$emit('click', evt);
      }
    } : {};
    return h('th', {
      on: _objectSpread(_objectSpread({}, on), evt),
      style: col.headerStyle,
      class: col.__thClass + (this.autoWidth === true ? ' q-table--col-auto-width' : '')
    }, child);
  }
});